<template>
	<div class="sharePage safe-top">
		<div class="banner" v-if="bannerlist.length > 0">
			<mt-swipe :auto="2000">
				<mt-swipe-item v-for="(item,index) in bannerlist" :key="index">
					<img :src="item"/>
				</mt-swipe-item>
			</mt-swipe>
		</div>
		<div class="detailWarp">
			<div class="info">
				<div class="left">
					<img :src="ajaxData.iconpath"/>
				</div>
				<div class="right">
					<div class="gameName">{{ajaxData.gamename}}</div>
					<div class="laberWarp">
						<label class="blue" v-for="(val,key) in ajaxData.signArr">{{val}}</label>
						<label class="blue">{{ajaxData.lang}}</label>
						<label class="green">{{ajaxData.size}}</label>
						<label class="orange">
							<div class="icon">
								<img :src="images.download"/>
							</div>
							{{ajaxData.downnum}}
						</label>
					</div>
				</div>
			</div>
			<div class="container" ref="container">
				<div class="detail" v-html="ajaxData.descript" ref="detail"></div>
				<div class="bottom" v-if="showMoreBtn">
					<div class="gradual"></div>
					<div class="more" @click="showMore">显示更多</div>
				</div>
			</div>
		</div>
		<div class="recommendWarp">
			<div class="title">
				<div class="icon">
					<img :src="images.remen"/>
				</div>
				<span>热门推荐</span>
			</div>
			<ul>
				<li v-for="(item,index) in hotData" :style="{backgroundImage: 'url(' + item.webcover + ')' }" v-if="index<4">
					<div class="info">
						<div class="gameName">{{item.gamename}}</div>
						<div class="synopsis">{{item.synopsis}}</div>
						<div class="label" v-if="item.tag">
							<span>{{item.tag}}</span>
						</div>
					</div>
					<div class="gamemask"></div>
				</li>
			</ul>
		</div>
		
		<div class="downloadWarp">
			<div>
				<div class="icon">
					<img :src="images.betop"/>
				</div>
				<div class="txt" @click="toDownLoad(true)">下载左游游戏厅</div>
			</div>
		</div>
		
		<mt-popup class="popup" v-model="popupVisible" popup-transition="popup-fade">
			<div>
				<div class="cancelBtn" @click="showMore(false)">
					<img :src="images.del"/>
				</div>
				<div class="title">游戏介绍</div>
				<div class="content" v-html="ajaxData.descript"></div>
				<div class="mask"></div>
					
			</div>
		</mt-popup>
		
		<mt-popup class="downLoadPopup" v-model="downLoadVisible" popup-transition="popup-fade">
			<div>
				<div class="txt">
					<p>手机无法安装左右PC客户端</p>
					<p>你可以前往左游App下载更多游戏哦</p>
				</div>
				<div class="btn download" @click="toDownLoad(false)">去下载</div>
				<div class="btn cancel" @click="showDownLoadMore(false)">取消</div>
			</div>
		</mt-popup>
	</div>
</template>

<script>
	import { Swipe, SwipeItem, Popup } from 'mint-ui';
	import { get, isPC } from 'assets/api/config'
	
	var img = {};
	img.remen = require('../../assets/images/remen.png');
	img.betop = require('../../assets/images/betop.png');
	img.del = require('../../assets/images/del.png');
	img.download = require('../../assets/images/mini_download.png');
	
	export default {
		data() {
			return {
				images: img,
				bannerlist:'',//banner数据
				ajaxData:'',//游戏数据
				hotData:'',//热门推荐
				showMoreBtn:false,//是否展示显示更多
				popupVisible:false,//是否展示popup
				downLoadVisible:false,//是否显示下载弹出层
			}
		},
		mounted: function() {
			this.init();
		},
		methods: {
			init(){
				let that = this;
				//游戏详情
				let data = {
					token: '30||45||||',
					act: 'pcgameinfos',
					gid: this.$route.params.id
				}
				
				get(data).then(function(res) {
					that.bannerlist = res.data.bannerlist;
					that.ajaxData = res.data;
				});
				
				//热门推荐
				let hotData = {
					act: 'pcGameSort',
				}
				
				get(hotData).then(function(res) {
					that.hotData = res.data.hot;
				});
			},
			showMore(bool){
				//控制详情弹窗状态
				this.popupVisible = bool;
			},
			showDownLoadMore(bool){
				//控制下载弹窗状态
				this.downLoadVisible = bool;
			},
			toDownLoad(boolean){
				//去下载
				if(isPC()){
					//是pc
					window.location.href="https://api.betopfun.com/web.php?act=downpcapp&ts=1556087695738&appid=1003&nettype=1&token=1&sign=1556087695738&apptype=pc";
				}else{
					if(boolean){
						//打开弹窗
						this.downLoadVisible = true;
					}else{
						//直接下载
						window.location.href="https://www.betopgame.com/#/";
					}
				}
			}
		},
		watch: {
			ajaxData() {
			  	//监听评论
			    this.$nextTick(function(){
			      	let containerHeight = window.getComputedStyle(this.$refs.container).height;
			      	let detailHeight = window.getComputedStyle(this.$refs.detail).height;
			      	
			      	if(parseInt(detailHeight) > parseInt(containerHeight)){
			      		this.showMoreBtn = true;
			      	}
			      	
					console.log('容器：',parseInt(containerHeight))
					console.log('详情：',parseInt(detailHeight))
			    });               
			},
		},

	}
</script>

<style lang="less" scoped>
	.sharePage{
		margin: 0 auto;
		max-width: 600PX;
		background-color: #fff;
		
		img{
			width: 100%;
			height: 100%;
		}
		
		.banner{
			height: 605px;
			max-height: 337PX;
			
			img{
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		
		.detailWarp{
			padding: 40px;
			border-bottom: 30px solid #eeeeee;
			
			.info{
				display: flex;
				align-items: center;
				
				.left{
					margin-right: 40px;
					width: 180px;
					height: 180px;
					max-width: 100PX;
					max-height: 100PX;
					border-radius: 40px;
					overflow: hidden;
				}
				
				.right{
					.gameName{
						margin-bottom: 25px;
						font-size: 39px;
						color: #333;
						text-align: left;
					}
					
					.laberWarp{
						/*display: flex;*/
						align-items: center;
						justify-content: flex-start;
						
						label{
							float: left;
							margin-right: 10px;
							margin-top: 5px;
							padding: 5px 12px;
							font-size: 30px;
							border-radius: 25px
						}
						
						.blue{
							border: 1px solid #519ac0;
							color: #519ac0;
						}
						
						.green{
							border: 1px solid #8cb574;
							color: #8cb574;
						}
						
						.orange{
							position: relative;
							display: flex;
							align-items: center;
							padding-left: 42px;
							border: 1px solid #ff915b;
							color: #ff915b;
							
							.icon{
								position: absolute;
								top: 8px;
								left: 10px;
								width: 28px;
							}
						}
					}
				}
			}
			
			.container{
				position: relative;
				max-height: 400px;
				margin-top: 40px;
				overflow: hidden;
				
				.detail{
					font-size: 34px;
					color: #666;
					text-align: left;
					line-height: 46px;
				}
				
				.bottom{
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
				}
				
				.gradual{
					height: 52px;
					background: -webkit-linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,1)); /* Safari 5.1 - 6.0 */
					background: -o-linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,1)); /* Opera 11.1 - 12.0 */
					background: -moz-linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,1)); /* Firefox 3.6 - 15 */
					background: linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,1)); /* 标准的语法 */
				}
				
				.more{
					text-align: center;
					font-size: 36px;
					color: #999;
					background-color: #fff;
					cursor: pointer;
				}
			}
			
		}
		
		.recommendWarp{
			padding: 40px;
			
			.title{
				position: relative;
				padding-left:60px;
				margin-bottom: 40px;
				text-align: left;
				
				.icon{
					position: absolute;
					left: 0;
					top: 4px;
					width: 40px;
					height: 38px;
				}
				
				span{
					font-size: 40px;
					color: #333;
				}
			}
			
			ul{
				li{
					position: relative;
					margin-bottom: 30px;
					list-style-type: none;
					height: 562px;
					border-radius: 20px;
					overflow: hidden;
					text-align: left;
					background-size: cover;
					color: #fff;
					overflow: hidden;
					
					.info{
						position: absolute;
						left: 50px;
						top: 0;
						margin-top: 60px;
						z-index: 999;
						
						.gameName{
							font-size: 40px;
							margin-bottom: 30px;
						}
						
						.synopsis{
							font-size: 36px;
						}
						
						.label{
							margin-top: 30px;
							
							span{
								font-size: 36px;
								padding: 8px 25px;
								border: 1px solid #fff;
								border-radius: 30px;
							}
						}
					}
					
					.gamemask{
					    position: absolute;
					    top: 0;
					    left: 0;
					    width: 100%;
					    height: 100%;
					    background: rgba(0,0,0,.3);
					}
				}
			}
		}
		
		.downloadWarp{
			position: fixed;
			bottom: 30px;
			width: 100%;
			z-index: 999;
			
			&>div{
				margin: 0 auto;
				width: 872px;
				height: 104px;
				line-height: 104px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #CE3D3E;
				color: #fff;
				text-align: center;
				border-radius: 60px;
				cursor: pointer;
			}
			
			.icon{
				display: flex;
				margin-right: 20px;
				width: 60px;
				height: 54px;
				
				img{
					width: 100%;
					height: 100%;
				}
			}
			
			.txt{
				font-size: 46px;
			}
		}
		
		.popup{
			width: 80%;
			max-height: 1200px;
			padding: 60px;
			border-radius: 20px;
			
			&>div{
				position: relative;
			}
			
			.cancelBtn{
				position: absolute;
				right: -20px;
				top: -20px;
				width: 40px;
				height: 40px;
				cursor: pointer;
			}
			
			.title{
				margin-bottom: 60px;
				font-size: 46px;
				color: #333;
				text-align: center;
			}
			
			.content{
				padding-bottom: 40px;
				margin-bottom: 40px;
				max-height: 930px;
				font-size: 42px;
				line-height: 64px;
				overflow: scroll;
				text-align: left;
			}
			
			.mask{
				position: absolute;
				width: 100%;
				height: 50px;
				left: 0;
				bottom: -40px;
				background: rgba(255,255,255,0.8);
				box-shadow: 0 -30px 10px rgba(255,255,255,0.8);
			}
		}
		
		.downLoadPopup{
			width: 880px;
			padding: 60px;
			border-radius: 20px;
			
			.txt{
				margin-bottom: 60px;
				
				p{
					text-align: center;
					font-size: 40px;
					color: #333;
				}
				
				p:first-child{
					margin-bottom: 40px;
				}
			}
			
			.btn{
				margin: 0 auto;
				width: 280px;
				height: 85px;
				line-height: 85px;
				font-size: 40px;
				border-radius: 50px;
				text-align: center;
			}
			
			.download{
				margin-bottom: 30px;
				background-color: #CE3D3E;
				color: #fff;
			}
			
			.cancel{
				border: 4px solid #CE3D3E;
				color: #CE3D3E;
				width: 272px;
				height: 77px;
				line-height: 77px;
			}
			
		}
	}
	
	@media only screen and (min-width: 700px) {
	   .sharePage{
	   		/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/  
			::-webkit-scrollbar  
			{  
			    width: 4PX;  /*滚动条宽度*/
			    height: 4PX;  /*滚动条高度*/
			}  
			  
			/*定义滚动条轨道 内阴影+圆角*/  
			::-webkit-scrollbar-track  
			{  
			    border-radius: 10PX;  /*滚动条的背景区域的圆角*/
			    background-color: #fff;/*滚动条的背景颜色*/  
			}  
			  
			/*定义滑块 内阴影+圆角*/  
			::-webkit-scrollbar-thumb  
			{  
			    border-radius: 10PX;  /*滚动条的圆角*/
			    background-color: #E6E7EA;  /*滚动条的背景颜色*/
			}
	   	
		   	.banner{
				height: 337PX;
				
				img{
					width: 100%;
					height: 100%;
				}
			}
			
			.detailWarp{
				padding: 25PX;
				border-bottom: 18PX solid #eee;
				
				.info{
					.left{
						margin-right: 24PX;
						width: 104PX;
						height: 104PX;
						border-radius: 20PX;
						overflow: hidden;
					}
					
					.right{
						.gameName{
							margin-bottom: 12PX;
							font-size: 24PX;
						}
						
						.laberWarp{
							label{
								margin-right: 10PX;
								padding: 4PX 6PX;
								font-size: 16PX;
								border-radius: 20PX
							}
							
							.orange{
								padding-left: 26PX;
								
								.icon{
									top: 6PX;
									left: 6PX;
									width: 16PX;
								}
							}
						}
					}
				}
				
				
				.container{
					max-height: 270PX;
					margin-top: 20PX;
					.detail{
						font-size: 20PX;
						line-height: 30PX;
					}
					
					.gradual{
						height: 25PX;
					}
					
					.more{
						text-align: center;
						font-size: 18PX;
						color: #999;
						background-color: #fff;
					}
				}
			}
			
			.recommendWarp{
				padding: 20PX;
				
				.title{
					padding-left:36PX;
					margin-bottom: 20PX;
					text-align: left;
					
					.icon{
						position: absolute;
						top: 3PX;
						width: 24PX;
						height: 23.46PX;
					}
					
					span{
						font-size: 22PX;
					}
				}
				
				ul{
					li{
						margin-bottom: 16PX;
						height: 325PX;
						border-radius: 10PX;
						
						.info{
							left: 28PX;
							top: 0;
							margin-top: 28PX;
							
							.gameName{
								font-size: 22PX;
								margin-bottom: 15PX;
							}
							
							.synopsis{
								font-size: 20PX;
							}
							
							.label{
								margin-top: 20PX;
								
								span{
									font-size: 18PX;
									padding: 4PX 12PX;
									border: 1px solid #fff;
									border-radius: 30PX;
								}
							}
						}
					}
				}
			}
			
			.downloadWarp{
				bottom: 20PX;
				width: 600PX;
				z-index: 999;
				
				&>div{
					margin: 0 auto;
					width: 80%;
					height: 64PX;
					line-height: 64PX;
					border-radius: 80PX;
				}
				
				.icon{
					margin-right: 10PX;
					width: 30PX;
					height: 27.2PX;
					
					img{
						width: 100%;
						height: 100%;
					}
				}
				
				.txt{
					font-size: 22PX;
					
					p{
						text-align: center;
					}
				}
			}
			
			.popup{
				width: 520PX;
				max-height: 660PX;
				padding: 20PX;
				border-radius: 10PX;
				
				.cancelBtn{
					right: 0;
					top: 0;
					width: 24PX;
					height: 24PX;
				}
				
				.title{
					font-size: 26PX;
					text-align: center;
					margin-bottom: 18PX;
				}
				
				.content{
					padding-bottom: 20PX;
					margin-bottom: 20PX;
					max-height: 500PX;
					font-size: 18PX;
					line-height: 28PX;
					overflow-y: scroll;
					overflow-x: hidden;
				}
				
				.mask{
					height: 20PX;
					left: 0;
					bottom: -20PX;
					background: rgba(255,255,255,0.8);
					box-shadow: 0 -20PX 5PX rgba(255,255,255,0.8);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/community/shareDetail.vue